import React, { useState, useEffect } from "react";
import QRCode from "qrcode";
import "./share.scss";

interface ShareProps {
	url: string;
}

export const Share = (props: ShareProps) => {
	const [qrCode, setQrCode] = useState<string>();

	useEffect(() => {
		QRCode.toDataURL(
			props.url,
			{ errorCorrectionLevel: "H", width: 1080 },
			(err, url) => {
				setQrCode(url);
			}
		);
	}, []);

	const share = () => {
		const nav: Navigator = window.navigator;
		if (nav.share) {
			nav.share({
				title: document.title,
				text: "Check out these slides",
				url: props.url,
			})
				.then(() => console.log("Successful share"))
				.catch((error) => console.log("Error sharing", error));
		} else {
			console.log("Device does not support sharing.");
		}
	};

	return (
		<>
			<div className="share">
				<img
					className="share__qr-code"
					tabIndex={0}
					role="button"
					title="share slides"
					onClick={(e) => {
						share();
					}}
					src={qrCode}
				/>
				<div className="share__url">{props.url}</div>
			</div>
		</>
	);
};
